import { AppShellContent, Button, Text } from "@assetwatch/ui";
import {
  createFileRoute,
  ErrorComponent,
  useRouter,
} from "@tanstack/react-router";
import { profileQueryOptions } from "../queries/useProfileQuery";
import { ProfileScreen } from "../screens/ProfileScreen";

class ProfileDataLoadError extends Error {
  constructor(readonly originalError: unknown) {
    super("Profile data failed to load.");
    this.name = "ProfileDataLoadError";
  }
}

function ProfileLoadError({ error }: { error: Error }) {
  const router = useRouter();
  if (!(error instanceof ProfileDataLoadError)) {
    return <ErrorComponent error={error} />;
  }
  return (
    <AppShellContent>
      <Text role="alert">Unable to load your profile. Try again.</Text>
      <Button variant="outline" onClick={() => void router.invalidate()}>
        Retry
      </Button>
    </AppShellContent>
  );
}

export const Route = createFileRoute("/_app/profile")({
  loader: async ({ context }) => {
    try {
      return await context.queryClient.ensureQueryData(profileQueryOptions());
    } catch (error) {
      throw new ProfileDataLoadError(error);
    }
  },
  pendingComponent: () => <AppShellContent pending>{null}</AppShellContent>,
  errorComponent: ProfileLoadError,
  component: ProfileScreen,
});
